import { object, string } from 'yup';
import { ProfileEntity } from '../../models';
import { EntityFormSchema, NotificationEmailFrequency } from '../../types';

export const ProfileNotificationEmailFrequencySchema = (): EntityFormSchema<ProfileEntity> => ({
  schema: object({
    notificationEmailFrequency: string().required().oneOf(Object.values(NotificationEmailFrequency)),
  }),
});
